import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { ActivatedRoute, Params, Router } from '@angular/router';
// import { FireBaseService } from '../../common/services/FireBase.service';
import { FireBaseService } from '../../common/services/FireBase.service';
import { BusinessService } from '../../common/services/Business.service';
import { AngularFireDatabase } from 'angularfire2/database';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { EvsUserService } from '../../common/services/EvsUser.service';
import { environment } from 'environments/environment';
import { ImageService } from 'app/pages/imageService';
import { ImportCratingService } from '../../../app/pages/admin/qrcode/import-crating/services/import-crating.services'
import { ToastrService } from 'ngx-toastr';
import { BusinessContactService } from '../../../app/pages/admin/evs/business/business-contact/services/business-contact.service';
import { TranslateService } from '@ngx-translate/core';

declare function baseTracking(appIdTracking);

declare function enterScreenView(screenName: any, contentType: any, referrer: any);

declare function visibleContent(regionName: any, contentName: any, index: any);

declare function clickTracking(regionName: any, contentName: any, target: any, payload: any);

declare function alertMsg(alertType: any, alertMessage: any);

declare function searchEvent(keywords: any, params: any, order: any, sort: any)

declare var $: any;
let that: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'admin-header',
  templateUrl: './admin-header.template.html',
  styleUrls: ['admin-header.css'],
  providers: [FireBaseService, BusinessService, EvsUserService],
})
export class AdminHeaderComponent implements OnInit {
  data: any;
  detail: any;
  items: any[] = [];
  offset = 0;
  limit = 10;
  size = 10;
  user: any = null;
  typeNav = '';
  newNoti: any = null;
  collapsed = false;
  inboxs: any = [];
  newInbox: any = null;
  code = '';
  @Output() navUpdated = new EventEmitter();
  @ViewChild('notiImport') notiImport: ModalDirective;
  modalRef: BsModalRef;
  message;
  logDataImport: any;
  link: any;
  // tslint:disable-next-line:member-ordering
  access_token;
  public listSuggestStamp: any
  currentLang: string = 'vi';

  constructor(
    private router: Router,
    private fbase: FireBaseService,
    private bussiness: BusinessService,
    private modalService: BsModalService,
    db: AngularFireDatabase,
    private activatedRoute: ActivatedRoute,
    private evsUserService: EvsUserService,
    private imageService: ImageService,
    private ImportCratingService: ImportCratingService,
    private toastr: ToastrService,
    private businessContactService: BusinessContactService,
    private translate: TranslateService
  ) {
    that = this;
    if (localStorage.getItem('User')) {
      this.user = JSON.parse(localStorage.getItem('User'));
    }
    // this.fbase.getLogin(); // Login firebase tạm đóng 14/5/2018
  }

  ngOnInit() {
    this.currentLang = this.translate.currentLang || this.translate.getDefaultLang() || 'vi';
    // this.getListSuggestStamp('')
    const distributionAgent = $('.searchCodeTemp');
    distributionAgent.select2({
      placeholder: '----- Tìm kiếm mã tem -----',
      allowClear: true,
      ajax: {
        delay: 500,
        url: `${environment.qrcode_url_aps}/map_code/search_relative`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('Access-Token')}`,
          'Content-Type': 'application/json',
        },
        dataType: 'json',
        data: function (params) {
          console.log('params', params);
          $('.select2-container').addClass('setIndex-1800');
          if (params.term) {
            return {
              code: params.term,
              page: 0,
              size: 50,
            };
          }
          return {
            code: '',
            page: 1,
            size: 50,
          };
        },
        // tslint:disable-next-line:no-shadowed-variable
        processResults: (data) => {
          // this.fakeData = data.data.items;
          console.log('data', data.data.items)
          return {
            results: data.data.items.map((item) => {
              if (item.c_qrm != '') {
                item.c_qrm = item.c_qrm + ';'
              }
              if (item.c_qri != '') {
                item.c_qri = item.c_qri + ';'
              }
              if (item.c_sms != '') {
                item.c_sms = item.c_sms + ';'
              }
              return {
                text: `Serial: ${item.prefix}-${item.number} (${item.c_qrm} ${item.c_qri} ${item.c_sms} ${item.c_serial})`,
                id: `${item.prefix}-${item.number}`,
              };
            }),
          };
        },
      },
    });
    this.businessContactService.profileBussinessUpdate$.subscribe((userUpdated) => {
      if (userUpdated) {
        this.user = userUpdated
        console.log('======= ', this.user)
      }
    });
    baseTracking(environment.appIdTracking)
    this.getPemission();
    this.access_token = localStorage.getItem('Access-Token');
    $('ul.dropdown-menu.li.panel-default').on('click', function (event) {
      // The event won't be propagated up to the document NODE and
      // therefore delegated events won't be fired
      event.stopPropagation();
    });
  }

  // tslint:disable-next-line:member-ordering
  public checkListSuggestStamp: boolean
  public showDropdown: boolean

  async getListSuggestStamp(code: string) {
    await this.evsUserService
      .getListSuggestStamp(code, 0, 150)
      .toPromise()
      .then((res: any) => {
        this.listSuggestStamp = res.data.items
        if (this.listSuggestStamp.length > 0) {
          this.checkListSuggestStamp = true
        } else {
          this.checkListSuggestStamp = false
        }
        this.listSuggestStamp.map((res) => {
          res.numberFormat = res.number
          if (res.c_qrm != '') {
            res.c_qrm = res.c_qrm + ';'
          }
          if (res.c_qri != '') {
            res.c_qri = res.c_qri + ';'
          }
          if (res.c_sms != '') {
            res.c_sms = res.c_sms + ';'
          }
        })
        console.log('ress', this.listSuggestStamp.this.checkListSuggestStamp)
      })
      .catch((err: any) => {
      });
  }

  changeLanguage(lang: string) {
    this.currentLang = lang;
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
  }

  patchValueInput(value: any) {
    console.log('valuessssssssss', value)
    $('#stampCode').prop('value', value);
    this.findCodeStamp();
    this.showDropdown = false
  }

  focusEvent(event: any) {
    console.log('0099999')
    this.showDropdown = true
    // console.log('vao focus')
    // if (event.target.value != '') {
    //   this.checkListSuggestStamp = true
    // } else {
    //   this.checkListSuggestStamp = false
    // }
    // setTimeout(() => {
    //   $('#dropdownMenuButton2').click();
    // }, 100)
  }

  inputEvent(event: any) {
    if (event.target.value != '') {
      console.log('khi có ký tự')
      this.checkListSuggestStamp = true
      this.getListSuggestStamp(event.target.value).then(r => console.log('11111', r))
      console.log('this.listSuggestStamp', this.listSuggestStamp)
    } else {
      this.checkListSuggestStamp = false
    }
  }

  getPemission() {
    let user: any = localStorage.getItem('User');
    if (user) {
      user = JSON.parse(user);
      this.evsUserService
        .getRoles(user.id)
        .toPromise()
        .then((res: any) => {
          if (!res.error) {
            const roles = res.data.my_permissions;
            const index = roles.indexOf(35);
            if (index > -1) {
              this.bussiness.refreshToken();
              if (localStorage.getItem('FireBase-Token')) {
                this.fbase
                  .getLogin(localStorage.getItem('FireBase-Token'))
                  .then(() => {
                    that.showNotify();
                  });
              }
              setInterval(() => {
                this.bussiness.refreshToken();
                if (localStorage.getItem('FireBase-Token')) {
                  this.fbase
                    .getLogin(localStorage.getItem('FireBase-Token'))
                    .then(() => {
                      that.showNotify();
                    });
                }
              }, 3000000);
              this.getInbox();
              setInterval(() => {
                this.getInbox();
              }, 60000);
              this.activatedRoute.queryParams.subscribe((params: Params) => {
                if (params.code) {
                  this.code = params.code;
                  this.findCode(this.code);
                } else {
                  this.code = '';
                }
              });
              this.fbase.receiveMessage();
            }
          }
        })
        .catch((err: any) => {
        });
    }
  }

  getInbox() {
    let user: any = localStorage.getItem('User');
    if (user) {
      user = JSON.parse(user);
      this.offset = 0;
      const option: any = {
        limit: 10,
        offset: this.offset,
      };

      this.bussiness
        .getInbox(option)
        .toPromise()
        .then((res) => {
          if (res) {
            if (res.data) {
              this.inboxs = res.data.data;
              // tslint:disable-next-line:comment-format
              //let listShow: any = [];
              let i = 0;
              this.inboxs.forEach((element) => {
                // if (element.type == 0) {
                //   if (element.to == parseInt(user.id)) {
                //     if (element && element.status == 0) i++;
                //     listShow.push(element);
                //   }
                // }
                // tslint:disable-next-line:curly
                if (element && element.status == 0) {
                  i++;
                }
              });
              this.newInbox = i > 0 ? i : null;
              //this.inboxs = listShow;
            }
          }
        });
    }
  }

  showMoreInbox() {
    let user: any = localStorage.getItem('User');
    if (user) {
      user = JSON.parse(user);
      this.evsUserService
        .getPermissions(user.id)
        .toPromise()
        .then((res: any) => {
          const roles = res.data.my_permissions;
          const index = roles.indexOf(35);
          if (index > -1) {
            this.offset += 10;
            const option: any = {
              limit: 10,
              offset: this.offset,
            };

            this.bussiness
              .getInbox(option)
              .toPromise()
              .then((res) => {
                if (res) {
                  if (res.data) {
                    if (res.data.data.length > 0) {
                      const inboxs = res.data.data;
                      const listShow: any = [];
                      const i = 0;
                      inboxs.forEach((element) => {
                        if (element.type == 0) {
                          if (element.to == parseInt(user.id)) {
                            listShow.push(element);
                          }
                        }
                      });
                      this.inboxs = this.inboxs.concat(listShow);
                    } else {
                      this.offset -= 10;
                    }
                  }
                }
              });
          }
        });
    }
  }

  shoInbox(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  readedMess(mess: any) {
    if (mess) {
      this.bussiness.readedMess(mess._id).subscribe((res) => {
        if (!res.error) {
          this.inboxs.forEach((element) => {
            if (element == mess) {
              element.status = 1;
              if (this.newInbox > 0) {
                this.newInbox--;
                // tslint:disable-next-line:curly
                if (this.newInbox <= 0) {
                  this.newInbox = null;
                }
              }
            }
          });
        }
      });
    }
  }

  convertTime(date: Date) {
    const time = new Date(date).getTime();
    const now = new Date().getTime();
    if (now > time) {
      const lineTime = (now - time) / 1000;
      if (lineTime >= 60 && lineTime < 3600) {
        const timeString = (lineTime / 60).toString().split('.');
        if (timeString.length > 0) {
          return timeString[0] + ' phút trước';
        }
      } else if (lineTime >= 3600 && lineTime < 86400) {
        const timeString = (lineTime / 3600).toString().split('.');
        if (timeString.length > 0) {
          return timeString[0] + ' giờ trước';
        }
      } else if (lineTime >= 86400 && lineTime < 604800) {
        const timeString = (lineTime / 86400).toString().split('.');
        if (timeString.length > 0) {
          return timeString[0] + ' ngày trước';
        }
      } else if (lineTime >= 604800) {
        const timeString = (lineTime / 604800).toString().split('.');
        if (timeString.length > 0) {
          return timeString[0] + ' tuần trước';
        }
      } else {
        return 'Vừa xong';
      }
    } else {
      return 'Không xác định';
    }
  }

  showMore(): void {
    // if (localStorage.getItem('FireBase-Token')) {
    //     let limit = this.limit + this.size;
    //     this.fbase.getChatList(limit).subscribe((data: any[]) => {
    //         if (data.length > 0) {
    //             this.limit = limit;
    //             this.items = data.reverse();
    //         }
    //     });
    // }
    window.open('notify_manager');
  }

  toggle_sidebar() {
    this.collapsed = !this.collapsed;
  }

  redirectNotify(item) {
    // let link = UtilityService.redriectNotify(item.target_type,item.target_id);
    // if(link.internal){
    //     this.router.navigate([link.url]);
    // }else{
    //     location.href='/admin'+link.url;
    // }
  }

  goHome() {
    location.href = '/';
  }

  notifiTracking() {
    clickTracking('qcheck_header_page', 'notify', 'notify_view', '')
  }

  userTracking() {
    clickTracking('qcheck_header_page', 'info_page', 'account_view', '')
  }

  showNotify() {
    this.fbase.getChatInfo().subscribe((numberNotRead) => {
      if (numberNotRead) {
        const roomSelect = this.fbase.getIdRoomChat();
        if (numberNotRead['unreadRooms']) {
          this.newNoti = numberNotRead['unreadRooms'][roomSelect]
            ? numberNotRead['unreadRooms'][roomSelect]
            : null;
          if (!this.newNoti) {
            this.newNoti = null;
          }
          this.fbase.getChatList(this.limit).subscribe((data) => {
            const listData: any = [];
            let count = 1;
            for (let i = data.length - 1; i >= 0; i--) {
              if (data[i]) {
                if (count <= numberNotRead['unreadRooms'][roomSelect]) {
                  data[i]['isReaded'] = false;
                } else {
                  data[i]['isReaded'] = true;
                }
                const time = this.dateBefore(data[i]['timestamp']);
                data[i]['time'] = time;
                listData.push(data[i]);
                count++;
              }
            }
            this.items = listData;
          });
        } else {
          this.newNoti = null;
          this.fbase.getChatList(this.limit).subscribe((data) => {
            const listData: any = [];
            let count = 1;
            for (let i = data.length - 1; i >= 0; i--) {
              if (data[i]) {
                data[i]['isReaded'] = true;
                const time = this.dateBefore(data[i]['timestamp']);
                data[i]['time'] = time;
                listData.push(data[i]);
                count++;
              }
            }
            this.items = listData;
          });
        }
      } else {
        this.newNoti = null;
        this.fbase.getChatList(this.limit).subscribe((data) => {
          const listData: any = [];
          let count = 1;
          for (let i = data.length - 1; i >= 0; i--) {
            if (data[i]) {
              data[i]['isReaded'] = true;
              const time = this.dateBefore(data[i]['timestamp']);
              data[i]['time'] = time;
              listData.push(data[i]);
              count++;
            }
          }
          this.items = listData;
        });
      }
    });
    //this.fbase.getChatInfo().update({ unread_count: 0 });
  }

  getNotiImportCrating(id) {
    this.ImportCratingService.getNotifi(id).subscribe((res) => {
      if (res.code === 1) {
        this.logDataImport = res.data;
        this.link = res.data.urlFile;
      }
      this.openModalImportFile();
    }, (error) => {
      this.toastr.error(error.message, 'Cảnh báo', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      }), this.closeModalImportFile()
    })
  }

  openModalImportFile() {
    this.notiImport.show();
  }

  closeModalImportFile() {
    this.notiImport.hide()
  }

  toPage(item) {
    this.fbase.readed();
    console.log('item: ', item);
    switch (item.target.extraInfo.type) {
      case 1: {
        this.router.navigate(['/qrcode/order']);
        break;
      }
      case 2: {
        this.router.navigate(['/qrcode/order']);
        break;
      }
      case 3: {
        this.router.navigate(['/qrcode/batchstamp/list']);
        break;
      }
      case 4: {
        this.router.navigate(['/qrcode/batchstamp/list']);
        break;
      }
      case 5: {
        this.router.navigate(['/qrcode/withdrawal']);
        break;
      }
      case 6: {
        this.router.navigate(['/qrcode/withdrawal']);
        break;
      }
      case 7: {
        this.router.navigate(['/qrcode/distribution']);
        break;
      }
      case 8: {
        this.router.navigate(['/evs/guarantee/logs']);
        break;
      }
      case 9: {
        this.router.navigate(['/evs/guarantee/logs']);
        break;
      }
      case 10: {
        this.router.navigate(['/evs/guarantee/logs']);
        break;
      }
      case 11: {
        this.router.navigate(['/evs/guarantee/logs']);
        break;
      }
      case 12: {
        this.router.navigate(['/evs/dashboard'], {
          queryParams: { tab: 5 },
        });
        break;
      }
      case 13: {
        this.router.navigate(['/evs/dashboard'], {
          queryParams: { tab: 5 },
        });
        break;
      }
      case 14: {
        this.router.navigate(['/qrcode/batchstamp/list']);
        break;
      }
      case 15: {
        this.router.navigate(['/qrcode/batchstamp/list']);
        break;
      }
      case 18: {
        this.router.navigate(['/qrcode/warning-overflow'], {
          queryParams: { tab: 1 },
        });
        break;
      }
      case 19: {
        this.router.navigate(['/qrcode/warning-overflow'], {
          queryParams: { tab: 2 },
        });
        break;
      }

      case 40: {
        this.router.navigate(['/qrcode/warning-overflow'], {
          queryParams: { tab: 2 },
        });
        break;
      }
      // case 41: {
      //   this.getNotiImportCrating(item.target.id);
      //   this.notiImport.show()
      //   break;
      // }
    }
  }


  hideNotifi() {
    $('#notifi').attr('aria-expanded', 'false');
    $('#showNotifi').removeClass('show');
  }

  loadmore() {
    const lastItem = this.items[this.items.length - 1];
    if (lastItem) {
      this.fbase.loadmore(lastItem.timestamp, this.limit).subscribe((data) => {
        const listData: any = [];
        for (let i = data.length - 2; i >= 0; i--) {
          if (data[i]) {
            data[i]['isReaded'] = true;
            const time = this.dateBefore(data[i]['timestamp']);
            data[i]['time'] = time;
            listData.push(data[i]);
          }
        }
        this.items = this.items.concat(listData);
      });
    }
  }

  dateBefore(time: any) {
    const now = new Date().getTime();
    if (now > time) {
      const lineTime = (now - time) / 1000;
      if (lineTime >= 60 && lineTime < 3600) {
        const timeString = (lineTime / 60).toString().split('.');
        if (timeString.length > 0) {
          return timeString[0] + ' phút trước';
        }
      } else if (lineTime >= 3600 && lineTime < 86400) {
        const timeString = (lineTime / 3600).toString().split('.');
        if (timeString.length > 0) {
          return timeString[0] + ' giờ trước';
        }
      } else if (lineTime >= 86400 && lineTime < 604800) {
        const timeString = (lineTime / 86400).toString().split('.');
        if (timeString.length > 0) {
          return timeString[0] + ' ngày trước';
        }
      } else if (lineTime >= 604800) {
        const timeString = (lineTime / 604800).toString().split('.');
        if (timeString.length > 0) {
          return timeString[0] + ' tuần trước';
        }
      } else {
        return 'Vừa xong';
      }
    } else {
      return 'Không xác định';
    }
  }

  findCode(code?: any) {
    // console.log(code);
    if (code) {
      this.router.navigate(['/find-stamp'], { queryParams: { code: code } });
    }
  }

  findCodeStamp() {
    const code = $('#stampCode').val()
    console.log(code);
    if (code) {
      this.router.navigate(['/find-stamp'], { queryParams: { code: code } });
    }
  }

  findStampTracking(code) {
    searchEvent(code, 'stamp', '', '');
  }

  manualTracking() {
    clickTracking('qcheck_header_page', 'guide', '', '');
  }

  loyalty() {
    const avatar = this.imageService.readSrcImage(
      this.user.avatar,
      'thumb_medium'
    );
    // window.open(`http://localhost:4200/auth/sync-account?id=${this.user.id}&name=${this.user.name}&phone=${this.user.phone}&avatar=${avatar}&access_token=${this.access_token}`, '_blank');
    window.open(
      `${environment.loyalty}/auth/sync-account?id=${this.user.id}&name=${this.user.name}&phone=${this.user.phone}&avatar=${avatar}&access_token=${this.access_token}`,
      '_blank'
    );
  }

  trackingJsDashboard() {
    clickTracking('qcheck_header_page', 'icheck_icon', 'qcheck_dashboardView', '')
  }

  trackGuide() {
    clickTracking('qcheck_header_page', 'guide', '', '')
  }

  trackNotification() {
    clickTracking('qcheck_header_page', 'notify', 'notify_view', '')
  }

  trackAccount() {
    clickTracking('qcheck_header_page', 'info_page', 'account_view', '')
  }
}



// WEBPACK FOOTER //
// /app/src/app/layout/header/admin-header.component.ts